import React, { ReactChild, ComponentProps, FC } from "react";
import { styled } from "../stitches.config";
import { ColorProps, SizeProps, VariantProps } from "../utils/types";
import { stitchesButtonStyles } from "../stitches/button";
import { LoadingIcon } from "./icons";

type StitchesButtonProps = ComponentProps<typeof StyledButton>;
export interface ButtonProps extends StitchesButtonProps {
  /** Provide a text for the button */
  children?: ReactChild;
  variant?: VariantProps;
  color?: ColorProps;
  size?: SizeProps;
  // Find svg type
  icon?: boolean;
  rounded?: SizeProps;
  squared?: SizeProps;
  loading?: boolean;
  round?: boolean;
}

const StyledButton = styled("button", stitchesButtonStyles);

export const Button: FC<ButtonProps> = ({
  variant,
  color,
  size = "base",
  icon = false,
  round = false,
  squared,
  loading = false,
  children,
  ...props
}) => (
  <StyledButton
    variant={variant}
    color={color}
    size={size}
    icon={icon}
    round={round}
    rounded={size}
    squared={squared}
    loading={loading}
    disabled={loading}
    {...props}
  >
    {loading ? <LoadingIcon color={color} /> : children}
  </StyledButton>
);
